import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { userApi } from "../../api/user-api";
import TopBar from "../../components/topBar";
import { getText } from "../../utils/util";
import Info from "./components/info";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";

export default function IdCard() {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [type, setType] = useState(true);
  const { t: translate } = useTranslation();

  const loadUserInfoData = async () => {
    const data = await userApi.userInfo();
    if (data.ok) {
      setUserInfo(data.data);
    }
  };

  const sendAuth = async (authData) => {
    const data = await userApi.auth({ ...authData, uid: authData.id });
    if (data.ok) {
      setUserInfo(data.data);
      navigate(-1);
    }
    Toast.show({ content: data.msg });
    loadUserInfoData();
  };
  useEffect(() => {
    loadUserInfoData();
  }, []);
  return (
    <div className="min-h-dvh w-full bg-neutral-900">
      <AcendexLayout
        hideBottomBar
        theme="light"
        pcTopBarTitle={translate(getText("身份驗證"))}
        mobileTopBarTitle={translate(getText("身份驗證"))}
      >
        <div className="md:max-w-3xl lg:max-w-4xl mx-auto">
          <Info userInfo={userInfo} sendAuth={sendAuth} />
        </div>
      </AcendexLayout>
    </div>
  );
}
